import { type LevelProgressNote } from '@/lib/types';
import { useCallback, useContext, useState } from 'react';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import TextEditor from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/utils/TextEditor';
import useApi from '@/lib/api/useApi';
import Space from '@/components/Space';
import useRubricsPortfolioApiEndpoint from '../../../../useRubricsPortfolioApiEndpoint';

type LevelProgressNoteEditorProps = {
  levelProgressNote: LevelProgressNote;
  onClose: () => void;
};

const LevelProgressNoteEditor = ({
  levelProgressNote,
  onClose,
}: LevelProgressNoteEditorProps) => {
  const api = useApi();
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const [, setPortfolio] = useContext(RubricsPortfolioContext);
  const [saving, setSaving] = useState(false);

  const handleSave = useCallback(
    async (value: string): Promise<void> => {
      setSaving(true);

      const updatedLevelProgressNote = await api.put<LevelProgressNote>(
        `${rubricsPortfolioApiEndpoint}/level-progress-notes/${levelProgressNote.id}`,
        {
          content: value,
        },
      );

      setPortfolio(portfolio => {
        portfolio.levelProgressNotes![levelProgressNote.levelId][
          levelProgressNote.id
        ] = {
          ...portfolio.levelProgressNotes![levelProgressNote.levelId][
            levelProgressNote.id
          ],
          ...updatedLevelProgressNote,
        };
      });

      setSaving(false);
      onClose();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [levelProgressNote.id, levelProgressNote.levelId],
  );

  return (
    <>
      <Space height={18} />
      <TextEditor
        initialValue={levelProgressNote.content}
        onCancel={onClose}
        onSave={handleSave}
        disabled={saving}
        disableSaveWhenEmpty
      />
    </>
  );
};

export default LevelProgressNoteEditor;
